export const KEY_CODES = {
    left: 'ArrowLeft',
    right: 'ArrowRight'
};
